import { flattenToStructuredList } from "./responseFlattener";

export const ARRAY_ITEM_LABELS = Object.freeze({
  children: "Ребенок",
  child: "Ребенок",
  childList: "Ребенок",

  familyMambers: "Член семьи",
  member: "Член семьи",

  stage: "Этап",
  stages: "Этап",
  statuses: "Статус",
  response_attachments: "Документ",

  gasCylinders: "Газовый баллон",
  positions: "Позиция",
  discrepancyPositions: "Позиция расхождения",
  visualPositions: "Визуальная позиция",

  natFundLineList: "Строка начисления",
  natFundLine: "Строка начисления",

  addresses: "Адрес",
  address_objects: "Адресный объект",
  operations: "Операция",

  attachments: "Вложение",
  errors: "Ошибка",

  estate_objects: "Объект недвижимости",
  object_infos: "Объект недвижимости",
  property: "Объект недвижимости",
  properties: "Объект недвижимости",

  applicants: "Участник",
  contracts: "Договор",

  rights: "Право",
  right_foundation: "Документ основания",
  charge_list: "Обременение",
  charge_foundation: "Документ основания",
  claims_and_deals: "Притязание",

  marriage_infos: "Брак",
  divorce_infos: "Расторжение брака",
  birth_infos: "Рождение",
  records: "Запись акта",

  document: "Документ",
  documents: "Документ",

  organization_leader: "Руководитель",
  organization_leaders: "Руководитель",
  activity: "Вид деятельности",
  founders_ul: "Учредитель (ЮЛ)",
  founders_fl: "Учредитель (ФЛ)",
  bin_reorganization_ul: "БИН",
  benefiziar: "Бенефициар",
  benefiziars: "Бенефициар",

  service_datas: "Сведение об оплате",

  reg_charges: "Запрет на регдействия",
  founder_charges: "Арест доли учредителя",
  ul_charges: "Арест доли ЮЛ",

  organizations: "Организация",
  persons: "Лицо",
  lawmen: "ЧСИ",

  vehicle: "Транспорт",
  vehicles: "Транспорт",
});

export function resolveArrayItemLabel(key, { t, getFieldTitle } = {}) {
  const tr = (s) => (typeof t === "function" ? t(s) : s);
  if (!key) return tr("элемент");

  if (ARRAY_ITEM_LABELS[key]) return tr(ARRAY_ITEM_LABELS[key]);

  for (const [prefix, label] of Object.entries(ARRAY_ITEM_LABELS)) {
    if (key.startsWith(prefix)) return tr(label);
  }

  if (typeof getFieldTitle === "function") {
    const title = getFieldTitle(key);
    if (title && title !== key) return title;
  }

  return tr("элемент");
}

export function summarizeArrayChoices(data, { locale = "ru" } = {}) {
  const result = { multi: [], single: [] };
  if (!data || typeof data !== "object" || Array.isArray(data)) return result;

  const structured = flattenToStructuredList(data, { locale });

  for (const item of structured) {
    if (item.type !== "array") continue;
    const count = item.children?.length || 0;
    if (count <= 0) continue;

    if (count === 1) {
      result.single.push({ path: item.path, key: item.key });
    } else {
      result.multi.push({ path: item.path, key: item.key, count });
    }
  }

  return result;
}
